import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsx as e } from "react/jsx-runtime";
import { TrailingTooltip as t } from "@vds-core/tooltips";
import { Feature as r, Body as a, Title as i } from "@vds-core/typography";
import { ColorTokens as l } from "@vds-tokens/color";
import o from "styled-components";
import { _findTooltipSize as s } from "../utils/TooltipSizeCalc.js";
var d = o.div.withConfig({
    displayName: "TitleWrapper",
    componentId: "VDS__sc-vmwz61-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  text-align: inherit;\n  margin-bottom: ", ";\n"])), function (_ref) {
    var e = _ref.$paddingBottom;
    return e;
  }),
  c = function c(o) {
    var c = o.size,
      n = o.primitive,
      u = o.children,
      m = o.bold,
      p = o.viewport,
      f = o.surface,
      y = o.isStandAlone,
      g = o.tooltip,
      b = o.color,
      S = o.id,
      L = function L(e) {
        switch (e) {
          case "featureXSmall":
            return "XSmall";
          case "titleSmall":
          case "featureSmall":
          case "bodySmall":
            return "small";
          case "titleMedium":
          case "featureMedium":
          case "bodyMedium":
            return "medium";
          case "titleLarge":
          case "bodyLarge":
            return "large";
          case "titleXLarge":
            return "XLarge";
          case "title2XLarge":
            return "2XLarge";
          default:
            return;
        }
      },
      x = "mobile" === p ? function (e) {
        switch (e) {
          case "bodySmall":
          case "bodyMedium":
          case "bodyLarge":
            return "4px";
          case "titleSmall":
          case "titleMedium":
          case "titleLarge":
            return "8px";
          case "titleXLarge":
            return "12px";
          case "title2XLarge":
          case "featureXSmall":
          case "featureSmall":
            return "16px";
          case "featureMedium":
            return "24px";
          default:
            return;
        }
      }(c) : function (e) {
        switch (e) {
          case "bodySmall":
          case "bodyMedium":
          case "bodyLarge":
            return "4px";
          case "titleSmall":
          case "titleMedium":
            return "8px";
          case "titleLarge":
            return "12px";
          case "titleXLarge":
            return "16px";
          case "title2XLarge":
          case "featureXSmall":
          case "featureSmall":
          case "featureMedium":
            return "24px";
          default:
            return;
        }
      }(c),
      h = "featureXSmall" === c || "featureSmall" === c || "featureMedium" === c ? r : ["bodySmall", "bodyMedium", "bodyLarge"].indexOf(c) > -1 ? a : i,
      X = function X() {
        return b || l.elements.primary["on".concat(f)].value;
      };
    return e(d, {
      size: c,
      id: "".concat(S, "-wrapper"),
      $paddingBottom: y ? 0 : x,
      children: g ? e(t, {
        typographySize: L(c),
        id: S,
        typographyType: "featureXSmall" === c || "featureSmall" === c || "featureMedium" === c ? "feature" : ["bodySmall", "bodyMedium", "bodyLarge"].indexOf(c) > -1 ? "body" : "title",
        typographyPrimitive: n,
        typographyColor: X(),
        bold: m,
        surface: f,
        iconFillColor: X(),
        disabled: g.disabled,
        tooltip: Object.assign(Object.assign({}, g), {
          ariaLabel: g.ariaLabel,
          closeButtonText: g.closeButtonText,
          containerId: g.containerId,
          size: s(g.size ? g.size : void 0, c, p),
          title: g.title,
          children: g.children
        }),
        children: u
      }) : e(h, {
        bold: m,
        id: S,
        size: L(c),
        primitive: n,
        children: u,
        color: X(),
        viewport: p
      })
    });
  };
c.displayName = "TitleLockupTitle", c.defaultProps = {
  size: "titleLarge",
  primitive: "h1",
  bold: !0,
  surface: "light",
  isStandAlone: !1
};
export { c as default };